module.exports = __webpack_public_path__ + "static/img/15.eeca7a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/15.png
// module id = 6ATE
// module chunks = 35